/** W15 GOT Data & Result Update pending list (manual p259, screenshot 154132). */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { GotReviewPendingPage } from "@/features/got/components/review-pages";

export const Route = createFileRoute("/_app/quality/got/review/")({
  beforeLoad: () => {
    if (!useAuth.getState().can("got.review")) throw redirect({ to: "/" });
  },
  component: GotReviewPendingPage,
});
